import React, { FC, useMemo } from 'react'
import { Stack, Text } from '@chakra-ui/react'

import { CustomFeedback, DescriptionItem } from 'components'

type View = {
  [key: string]: JSX.Element
}

type Props = {
  entity: any
  metadataPrefix: string
  metadataIndexes?: number[]
  showFeedbackVariant?: 'CUSTOM_FEEDBACK' | 'ONLY_TEXT'
  direction?: 'column' | 'row'
}

const MetadatasList: FC<Props> = ({
  direction = 'column',
  showFeedbackVariant = 'CUSTOM_FEEDBACK',
  metadataIndexes = [1, 2, 3, 4, 5, 6, 7],
  entity,
  metadataPrefix,
}) => {
  const metadatasWithIndexes = useMemo(() => {
    return metadataIndexes.filter((index) => {
      const label = entity[`${metadataPrefix}_${index}_label`]
      return label !== null
    }, [])
  }, [])

  const ComponentFeedback = useMemo(() => {
    const feedbackViews: View = {
      CUSTOM_FEEDBACK: <CustomFeedback context="withoutMetadatas" />,
      ONLY_TEXT: <Text variant="noData">Nenhuma informação complementar encontrada</Text>,
    }
    return feedbackViews[showFeedbackVariant]
  }, [])

  if (metadatasWithIndexes.length === 0) {
    return ComponentFeedback
  }

  return (
    <Stack spacing={4}>
      {metadatasWithIndexes.map((index) => {
        const label = entity[`${metadataPrefix}_${index}_label`]
        const value = entity[`info_${index}`]

        return <DescriptionItem direction={direction} key={index} label={label as string} value={value as string} />
      })}
    </Stack>
  )
}

export default MetadatasList
